import { useMemo, useState } from 'react'

import { Fullscreen as FullscreenIcon } from '@mui/icons-material'

import { ChartModal } from './ChartModal'
import ProductsBubbleChart from "./ProductsBubbleChart"
import SatisfactionChart from "./SatisfactionChart"
import RestrictedChart from "./RestrictedChart"

import { createHomeGraphicsViewModel } from './graphics-data'

import {
	renderSatisfactionChart,
	renderBubbleChart,
} from "../../../services/utils"

const LoadingPanel = () => {
	return (
		<section className="scout-panel scout-panel--content scout-graphics-panel scout-loading-block scout-loading-panel">
			<div className="scout-panel__heading scout-graphics-panel__heading">
				<span className="scout-loading-line scout-loading-line--text scout-loading-line--medium" />
				<span className="scout-loading-dot" />
			</div>
			<div className="scout-graphics-loading-body">
				<div className="scout-loading-stack">
					{Array.from({ length: 3 }).map((_, index) => (
						<div key={`graphics-loading-${index}`} className="scout-loading-metric-row">
							<div>
								<span className="scout-loading-line scout-loading-line--title" />
								<span className="scout-loading-line scout-loading-line--text scout-loading-line--short" />
							</div>
							<span className="scout-loading-bar" />
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

const HomeGraphicsSection = ({ analytics, loading = false, selectedAccount = null, useMockData = true, enterprise = null }) => {
	const [mobileOpen, setMobileOpen] = useState(null)
	const viewModel = useMemo(() => createHomeGraphicsViewModel({ analytics, selectedAccount, useMockData }), [analytics, selectedAccount, useMockData])
	const showEmptyState = !viewModel.hasData

	if (loading) {
		return (
			<div className="scout-graphics-grid">
				{Array.from({ length: 2 }).map((_, index) => (
					<LoadingPanel key={`graphics-panel-loading-${index}`} />
				))}
			</div>
		)
	}

	const satisfactionChart = renderSatisfactionChart(enterprise)
		? <SatisfactionChart data={viewModel.satisfaction} empty={showEmptyState} />
		: <RestrictedChart title="Índice de Satisfação" />

	const productsChart = renderBubbleChart(enterprise)
		? <ProductsBubbleChart data={viewModel.products} empty={showEmptyState} />
		: <RestrictedChart title="Produtos e Serviços" />

	return (
		<>
			<div className="scout-graphics-grid">
				<div className="scout-graphics-panel-wrapper">
					{satisfactionChart}
					<button
						type="button"
						className="scout-graphics-expand-trigger"
						onClick={() => setMobileOpen('satisfaction')}
						aria-label="Expandir Índice de Satisfação"
					>
						<FullscreenIcon fontSize="small" />
						<span>Ver gráfico</span>
					</button>
				</div>
				<div className="scout-graphics-panel-wrapper">
					{productsChart}
					<button
						type="button"
						className="scout-graphics-expand-trigger"
						onClick={() => setMobileOpen('products')}
						aria-label="Expandir Produtos e Serviços"
					>
						<FullscreenIcon fontSize="small" />
						<span>Ver gráfico</span>
					</button>
				</div>
			</div>

			{mobileOpen === 'satisfaction' && (
				<ChartModal title="Índice de Satisfação" onClose={() => setMobileOpen(null)}>
					{satisfactionChart}
				</ChartModal>
			)}
			{mobileOpen === 'products' && (
				<ChartModal title="Produtos e Serviços" onClose={() => setMobileOpen(null)}>
					{productsChart}
				</ChartModal>
			)}
		</>
	)
}

export default HomeGraphicsSection
